import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import {
  setScheduleType,
  setActivities,
} from '../../../actions/dive-operator-actions'
import ActivityFilters from '../ActivityFilters/ActivityFilters'
import Proptypes from 'prop-types'
import ActivitySlider from './ActivitySlider'

export const sections = {
  courses: {
    title: <FormattedMessage id='our_courses' defaultMessage='Our Courses' />,
  },
  other: {
    title: (
      <FormattedMessage
        id='other-activities'
        defaultMessage='Other Activities'
      />
    ),
    widgetTitle: (
      <FormattedMessage id='activities' defaultMessage='Activities' />
    ),
  },
}

function Diving({
  diveCenterId,
  type,
  selectedCurrency,
  courseFilters,
  isWidget,
}) {
  return (
    <div className='wrapper trip-wrapper'>
      <h3 className='do-section-title'>
        {isWidget ? sections.other.widgetTitle : sections[type].title}
      </h3>
      <ActivityFilters activityType={type} courseFilters={courseFilters} />
      <ActivitySlider
        diveCenterId={diveCenterId}
        type={type}
        selectedCurrency={selectedCurrency}
        courseFilters={courseFilters}
        isWidget={isWidget}
      />
    </div>
  )
}

export default connect(
  ({ activitesList, selectedCurrency }) => ({
    activitesList,
    selectedCurrency,
  }),
  {
    setScheduleType,
    setActivities,
  },
)(Diving)

Diving.propTypes = {
  diveCenterId: Proptypes.string,
  type: Proptypes.string,
  selectedCurrency: Proptypes.string,
  courseFilters: Proptypes.array,
  isWidget: Proptypes.bool,
}
